const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',
  FORM_ERROR: 'FORM_ERROR'
};

export default alertConstants;
